import React, { memo } from 'react'

import { Alert } from '@frame/ui-primitives/alert'

import { cn } from '@frame/lib/utils/cn'
import { DataAttribute } from '@frame/types'
import { Transition } from '@headlessui/react'

type Props = {
  showErrors: boolean
  errorMessages: string[]
  hasFiles: boolean
  onAfterLeave: () => void
}

export const ErrorAlert = memo(function ErrorAlert({ showErrors, errorMessages, hasFiles, onAfterLeave }: Props) {
  return (
    <Transition
      show={showErrors}
      as="div"
      enter="ease-out duration-300"
      enterFrom="opacity-0 translate-y-[20px]"
      enterTo="opacity-100 translate-y-0"
      leave="ease-in duration-300"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 translate-y-[20px]"
      className={cn('absolute z-10 mx-5 w-[calc(100%-48px)]', hasFiles ? 'bottom-[158px]' : 'bottom-[98px]')}
      afterLeave={onAfterLeave}
    >
      <Alert variant="error" data-cy={DataAttribute.FILE_UPLOAD_ERROR}>
        <ul className="pl-2">
          {errorMessages.map((message) => (
            <li className="list-outside list-disc text-error" key={message}>
              {message}
            </li>
          ))}
        </ul>
      </Alert>
    </Transition>
  )
})
